import axios from "axios";

export const getEmployees = async (idCompany) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
  let apiUrl= `http://${url}:4000/api/v1/boletaDigital/getEmployees`
  //let apiUrl= `http://localhost:4000/api/v1/boletaDigital/getEmployees`
  if(idCompany) apiUrl+=`?idCompany=${idCompany}`
  const config = {
    method: "GET",
    url: apiUrl,
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
